import {
  DamageTypeDto,
  VehicleDamageDataDto,
  VehicleDamageDataInputDto,
  VehicleDamageDto,
  VehicleDamageFullReferenceDto,
  VehicleDamageReferenceDto,
  VehiclePartTypeDto,
} from "@/core/api/generated/v1";

import { IdHelper } from "../../helpers/id";
import { Mapper } from "../mapper";

/** Any entity DTO type according to @type EntityFormType */
export type VehicleDamageDtoAny =
  | VehicleDamageDto
  | VehicleDamageReferenceDto
  | VehicleDamageFullReferenceDto
  | VehicleDamageDataDto
  | VehicleDamageDataInputDto
  | VehicleDamageDataInputDtoLocal;

/** All entity DTO types according to @type EntityFormType */
export type VehicleDamageDtoAll = VehicleDamageDto &
  VehicleDamageReferenceDto &
  VehicleDamageFullReferenceDto &
  VehicleDamageDataDto &
  VehicleDamageDataInputDto &
  VehicleDamageDataInputDtoLocal;

/** Any entity data DTO type. */
export type VehicleDamageDataDtoAny =
  | VehicleDamageDataDto
  | VehicleDamageDataInputDto
  | VehicleDamageDataInputDtoLocal;

/** All entity data DTO types. */
export type VehicleDamageDataDtoAll = VehicleDamageDataDto &
  VehicleDamageDataInputDto &
  VehicleDamageDataInputDtoLocal;

/** DTO with extra local props. */
export interface VehicleDamageDataInputDtoLocal extends VehicleDamageDataInputDto {
  /** Original id before the data was updated locally and id changed to new FE temp id.
   * Use only to match new updated data to old data before the specific update.
   */
  idBeforeUpdateLocal?: string | null;
  partType?: Nil<VehicleDamageDataDto["partType"]>;
  /** DTO selected via autocomplete.  */
  partTypeLocal?: Nil<VehiclePartTypeDto>;
  damageType?: Nil<VehicleDamageDataDto["damageType"]>;
  /** DTO selected via autocomplete.  */
  damageTypeLocal?: Nil<DamageTypeDto>;
}

export class VehicleDamageMapper {
  public static mapToDataInputDto(source: VehicleDamageDtoAny): VehicleDamageDataInputDtoLocal {
    const source2 = source as VehicleDamageDtoAll;
    let dest: VehicleDamageDataInputDtoLocal = {
      ...source,
    };
    dest = Mapper.baseEntity.mapToDataInputDtoLocal(source, dest);
    dest = {
      ...dest,
      id: dest.id || IdHelper.newTempFeId(),
      partTypeId: source2?.partType?.id || source2?.partTypeId || undefined,
      partType: source2?.partType || undefined,
      partTypeLocal: source2?.partTypeLocal || undefined,
      damageTypeId: source2?.damageType?.id || source2?.damageTypeId || undefined,
      damageType: source2?.damageType || undefined,
      damageTypeLocal: source2?.damageTypeLocal || undefined,
      visualModelId: source2?.visualModelId || source2?.visualModel?.id || undefined,
    };
    return dest;
  }

  public static mapToDataInputDtoForBe(
    source: VehicleDamageDataInputDtoLocal,
  ): VehicleDamageDataInputDto {
    const dest: VehicleDamageDataInputDtoLocal = {
      ...source,
      partType: undefined,
      partTypeLocal: undefined,
      damageType: undefined,
      damageTypeLocal: undefined,
    };
    return Mapper.baseEntity.mapToDataInputDtoForBe(dest);
  }
}
